export default __webpack_public_path__ + "static/media/gnfsa-icon.defe9b54.png";